import React, { useState, useEffect } from "react";
import { Button, Form, Input, Space } from "antd";
import {
  MobileOutlined,
  LockOutlined,
  MessageOutlined,
} from "@ant-design/icons";
import { gql, useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";

function ResetPassForm({ resend, smsExpiresAt, mobile }) {
  const [error, setError] = useState("");
  const [secondsToEnd, setSecondsToEnd] = useState(smsExpiresAt * 60);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const RESETPASS = gql`
    mutation authReset2($authReset2Input: AuthReset2Input!) {
      authReset2(authReset2Input: $authReset2Input) {
        accessToken
        expiresAt
        refreshToken
        userRole
      }
    }
  `;

  const [runAuthReset2, authReset2] = useMutation(RESETPASS, {
    onCompleted(data) {
      const userRole = data?.authReset2.userRole;
      localStorage.setItem("accessToken", data?.authReset2.accessToken);
      localStorage.setItem("expiresAt", data?.authReset2.expiresAt);
      localStorage.setItem("refreshToken", data?.authReset2.refreshToken);
      localStorage.setItem("role", data?.authReset2?.userRole);
      userRole === "ADMIN" ? navigate("/admin-users") : navigate("/dashboard");
    },
    onError(error) {
      setError(error.message);
    },
  });

  useEffect(() => {
    form.setFieldValue("mobile", mobile)
    let x = setTimeout(() => {
      setSecondsToEnd(secondsToEnd - 1);
    }, 1000);

    if (secondsToEnd === 0) {
      return () => clearTimeout(x);
    }
  }, [secondsToEnd]);

  const doAuthReset2 = (input) => {
    const authReset2Input = { ...input, mobile };
    runAuthReset2({
      variables: {
        authReset2Input,
      },
    });
  };

  return (
    <div>
      <Form name="normal_login" className="login-form" onFinish={doAuthReset2} form={form}>
        <Form.Item
          name="mobile"
          style={{ marginBottom: "30px" }}
          validateStatus={error && "error"}
          rules={[
            {
              required: true,
              message: "لطفا شماره همراه خود را وارد کنید!",
            }
          ]}
        >
          <Input
            size="large"
            className="form-input"
            prefix={<MobileOutlined className="site-form-item-icon" />}
            
            readOnly
          />
        </Form.Item>

        <Form.Item
          style={{ marginBottom: "30px" }}
          name="resetOtp"
          rules={[
            {
              required: true,
              message: "لطفا کد ارسال شده را وارد کنید!",
            },
          ]}
          validateStatus={error && "error"}
          help={error}
        >
          <Input
            size="large"
            className="form-input"
            prefix={<MessageOutlined className="site-form-item-icon" />}
            placeholder=" کد یکبار مصرف "
          />
        </Form.Item>

        <Form.Item
          name="password"
          style={{ marginBottom: "30px" }}
          rules={[
            {
              required: true,
              message: "لطفا رمز عبور جدید خود را وارد کنید!",
            },
          ]}
          validateStatus={error && "error"}
          help={error}
        >
          <Input.Password
            size="large"
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="رمز عبور جدید"
          />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              loading={authReset2.loading && true}
              disabled={!secondsToEnd}
            >
              تغییر رمز و ورود
              <span style={{ width: "25px" }}>{secondsToEnd}</span>
            </Button>
            <Button type="link" onClick={resend}>
              تغییر موبایل
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
}

export default ResetPassForm;
